// src/pages/OurStory.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function OurStory() {
  const { t } = useTranslation();

  return (
    <section className="pt-36 pb-24 bg-accent" aria-labelledby="our-story-title">
      <div className="max-w-6xl mx-auto px-4">
        {/* Page header */}
        <header className="text-center max-w-3xl mx-auto">
          <h1
            id="our-story-title"
            className="font-display text-5xl md:text-6xl text-gray-900 tracking-tight"
          >
            {t("ourStory.title")}
          </h1>
  
          <div className="w-24 h-1 bg-secondary mx-auto mt-6 rounded-full" />
        </header>

        {/* Main block */}
        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Image card */}
          <figure className="rounded-2xl overflow-hidden shadow-xl bg-white">
            <img
              src="/assets/images/Slider_002.jpg"
              alt={t("ourStory.imageAlt")}
              className="w-full h-[400px] md:h-[400px] object-cover"
            />
          </figure>

          {/* Copy */}
          <article>


            <p className="text-gray-800 leading-8 text-lg mb-5">
              {t("ourStory.section1.p1")}
            </p>

            <p className="text-gray-800 leading-8 text-lg">
              {t("ourStory.section1.p2")}
            </p>

            <div className="mt-8">
              <Link
                to="/menu"
                className="inline-flex items-center rounded-full border border-secondary/70 px-6 py-3 text-secondary font-medium hover:bg-secondary/10 transition-colors"
              >
                {t("viewMenu")}
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
